import React from 'react';
import ReactDOM from 'react-dom';
//import App from './App';
import Feed from './Feed';
import './index.css';

const imageFeed = '/wp-json/live-image-feed/v1/pics/';

/*ReactDOM.render(
  <App />,
  document.getElementById('root')
);*/
// lets see if we can move draggable out of #feed
/*const rejig = function(){
	const parent = document.getElementById('feed');
	console.log(parent.innerHTML);
	parent.outerHTML = parent.innerHTML;
}*/

window.setTimeout(function(){
	ReactDOM.render(
	  <Feed imageFeed={imageFeed} />,
	  document.getElementById('feed'),
	  //rejig
	);
}, 7000);




// WEBPACK FOOTER //
// ./src/index.js